import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-signatureInput-control-label-view, [app-signatureInput-control-label-view]',
  templateUrl: './signatureInput-control-label-view.component.html',
  styleUrls: ['./signatureInput-control-label-view.component.scss']
})
export class SignatureInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
